import { useLocation } from 'react-router-dom';
// import { Box } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import AuthProvider from 'context/authContext';
import { DriversAdjustmentProvider } from 'context/driversAdjustmentContext';
import 'matchmedia-polyfill';
import Navigation from 'navigation';
import AppWrapper from 'container/AppWrapper';

import CustomToastComponent from './CustomToast/toaster';
import SharedLoader from './FullScreenLoader/SharedLoader';
import Header from './Header';
import MDHeader from './MDHeader';

interface Properties {
  flags?: any;
}

const App = ({ flags }: Properties) => {
  const { pathname } = useLocation();
  const isLoginPage = pathname === '/';
  const isSplashPage = pathname.includes('/create');
  const isChangePasswordPage = pathname.includes('/change-password');
  const isSetPasswordPage = pathname.includes('/set-password');
  const isSetNewPasswordPage = pathname.includes('/set-new-password');
  const isWelcomePage = pathname.includes('/user/welcome');
  const isShareModelPage = pathname.includes('/share-model');
  const isSignupPage = pathname.includes('/signup');
  const isInvitationModal = pathname.includes('/invitation');

  return (
    // <Box overflow={'hidden'} maxH={'100vh'} maxWidth={'100vw'}>
    // <Box>
    <AuthProvider>
      <AppWrapper>
        <SharedLoader />
        <DriversAdjustmentProvider>
          {isLoginPage ||
          isSplashPage ||
          isChangePasswordPage ||
          isSetNewPasswordPage ||
          isSetPasswordPage ||
          isSignupPage ||
          isWelcomePage ||
          isInvitationModal ||
          isShareModelPage ? null : (
            <>{flags?.blox1261MultiDimensionalityFiltering ? <MDHeader /> : <Header />}</>
          )}
          <CustomToastComponent />
          <Navigation />
        </DriversAdjustmentProvider>
        {/* <VersionComponent /> */}
      </AppWrapper>
    </AuthProvider>
    // </Box>
  );
};

export default withLDConsumer()(App);
